import { cn } from '@/lib/utils'

interface OutOfServiceLabelProps {
  /** `standalone` renders "OUT OF SERVICE" on its own line; `inline` renders "(OUT OF SERVICE)" for use next to a value like USDOT. */
  variant?: 'standalone' | 'inline'
  className?: string
}

export function OutOfServiceLabel({
  variant = 'standalone',
  className,
}: OutOfServiceLabelProps) {
  return (
    <span className={cn('text-destructive font-bold', className)}>
      {variant === 'inline' ? '(OUT OF SERVICE)' : 'OUT OF SERVICE'}
    </span>
  )
}
